import { Reducer } from "redux";
import Penalty from "../../models/penalty/Penalty";
import { PenaltyGetActionTypes } from "./types";

export interface PenaltyState {
    penalty?: Penalty;
}

const unloadedState: PenaltyState = { penalty: undefined };

export const penaltyReducer: Reducer<PenaltyState> = (state: PenaltyState | undefined, action): PenaltyState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case PenaltyGetActionTypes.REQUEST:
        case PenaltyGetActionTypes.ERROR:
        case PenaltyGetActionTypes.CLEAR:
            return { ...state, penalty: undefined };
        case PenaltyGetActionTypes.SUCCESS:
            return { ...state, penalty: { ...action.payload } };
        default:
            return state;
    }
};
